import React from "react";
import { connect } from "react-redux";

import {setGroheFiltersOpened} from "../../../../../actions/groheFunctions";
import {setLookViewType} from "../../../../../actions/lookFunctions";
import LookMainCategory from "../../../lookNavigation/lookMain/lookCategory/lookMainCategory";
import GroheFeaturesHeader from "./groheFeaturesHeader";
import {hideFeatureSection} from "../../../lookNavigation/lookFunctions2";

const GroheFeatures = (props) => {

  const {lookActiveCategory, filtersOpened, lookOpened, isMobile, lookActiveFeature, lookCompatabilityAlert} = props;

  if (isMobile) {
    return (
      <section className={"grohe-features" + (lookActiveCategory && lookOpened ? " grohe-features--opened" : "")}>
        {lookActiveCategory ? <LookMainCategory/> : null}
      </section>
    )
  }

  const showFeaturesOnly = hideFeatureSection(lookOpened, lookActiveCategory, lookActiveFeature, lookCompatabilityAlert);

  return (
    <section className={"grohe-features" + (lookActiveCategory && lookOpened ? " grohe-features--opened" : "")
      + (showFeaturesOnly ? " grohe-features--only" : "") + (filtersOpened ? " grohe-features--only--with-filters" : "")}>
      <GroheFeaturesHeader/>
      {lookActiveCategory ? <LookMainCategory/> : null}
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveCategory, lookViewType, lookOpened, lookActiveFeature, lookCompatabilityAlert} = store.lookState;
  const {activeTheme, isMobile} = store.serverState;
  const {filtersOpened} = store.groheState;
  const {selectedFilters} = store.filterState;
  return {
    lookOpened,
    lookViewType,
    lookActiveCategory,
    lookCompatabilityAlert,
    lookActiveFeature,
    activeTheme,
    filtersOpened,
    isMobile,
    selectedFilters,
  };
};

const mapDispatchToProps = {
  setGroheFiltersOpened,
  setLookViewType,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatures)
)
